<template>

  <div class="">

      <div class="clearfix row py-2 mb-2 no-margin">
          <div class="col-sm-12 company-form-box-title pb-3 d-flex align-items-end">
              <div>Pending Approval</div>
          </div>

          <div class="col-sm-12">
            <h5 class="text-center text-primary">Select Approval Mode</h5>
            <b-form-group class="noc-tab-legends w-100">
              <b-form-radio-group class="noc-tab-btns w-100 " v-model="current_module" buttons button-variant="outline-secondary" name="module"
                  v-validate="'required'" data-vv-as="Module" @change="changeModule">
                  <b-form-radio :value="1"><span>Leave Applications</span></b-form-radio>
                  <b-form-radio :value="2"><span>Attendance Mobility</span></b-form-radio>
                  <b-form-radio :value="3"><span>Attendance Adjustment</span></b-form-radio>
                  <b-form-radio :value="4"><span>Swap Request</span></b-form-radio>
              </b-form-radio-group>
              <b-form-invalid-feedback>
                  {{ veeErrors.first('noc_type') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-sm-6">
            <h4 class="mb-2 mt-3">{{ modules[current_module] }}</h4>
            <p>Manage {{ modules[current_module] }} requests for employees under your approval layer.</p>
          </div>

          <div class="col-sm-3">
            <b-form-group v-if="current_module == 2" id="application_date-group" label="Date" label-for="application_date">
              <b-input-group class="mb-3">
                <b-form-input @input="getQueue" id="application_date" name="application_date" v-model="application_date" v-validate="{ required: false, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('application_date')" aria-describedby="application_date-feedback" data-vv-as="Date"/>
                <b-input-group-append>
                  <b-form-datepicker :max="new Date()" @input="getQueue" id="day_one" button-only right locale="en-US" v-model="application_date" />
                </b-input-group-append>
                <b-form-invalid-feedback id="application_date-feedback"> {{ veeErrors.first('application_date') }} </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
        <div class="col-sm-3 d-flex align-items-end justify-content-end mb-3" v-if="current_module == 2 || current_module == 3">
            <b-dropdown text="Bulk Option" class="trz-custom-dropdown ">
                <b-dropdown-group id="bulk_options-group">
                    <b-dropdown-item @click="confirmUpdateStatus(1)" ><b-icon icon="check-circle" class="mr-2" scale="1"></b-icon>Approve Selected</b-dropdown-item>
                    <b-dropdown-item @click="confirmUpdateStatus(2)" ><b-icon icon="x-circle" class="mr-2" scale="1"></b-icon>Reject Selected</b-dropdown-item>
                </b-dropdown-group>
            </b-dropdown>
        </div>
      </div>
      <div class="row justify-content-center no-margin" v-if="current_module==1">
        <div class="col-sm-12">
          <b-overlay :show="showoverlay_list" rounded="sm">
            <div class="b-overlay-wrap position-relative">
              <table class="table dataTable">
                <thead class="table-head">
                <tr class="">
                  <td class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">

                    <template v-if="column.name !='to' && column.name !='from'">
                      <label class="custom-label"><span>{{column.label}}</span></label>
                    </template>
                    <template v-else>
                      <label class="custom-label"><span> {{column.label}}</span>
                        <div class="table-header">
                          <div class="table sub-header">(YYYY-MM-DD)</div>
                        </div>
                      </label>
                    </template>
                  </td>
                  <td class="text-right">
                    Action
                  </td>
                </tr>
                </thead>
                <tbody>
                <template v-for="(leave , n) in paginatedData">
                  <tr class="table-row hover-bg" :key="n">
                    <td class=" ">
                      <div class="img-holder">
                        <img v-bind:src="$api_url+'/avatar/'+ leave.company_id + '/' + leave.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                      </div>
                      <div class="name-holder">
                        {{leave.employee_name}}<br />
                        <span class="txt-alt">{{leave.employee_code}}</span>
                      </div>
                    </td>
                    <td class="">
                      {{leave.jobposition}}
                    </td>
                    <td class="">
                      {{leave.department}}
                    </td>
                    <td class="">
                      <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                      {{leave.leave_type}}
                    </td>
                    <td class="">
                      {{leave.from}}
                    </td>
                    <td class="">
                      {{ leave.to }}
                    </td>
                    <td class="">

                      <template v-if="leave.leave_day == 0">
                        {{leave.number_of_days}}
                        <span v-if="leave.number_of_days > 1">days</span>
                        <span v-else>day</span>
                      </template>
                      <template v-else-if="leave.leave_day == 1">First Half</template>
                      <template v-else-if="leave.leave_day == 2">Second Half</template>
                    </td>
                    <td v-if="roster == 1">
                      <template v-if="leave.shifts && Object.keys(leave.shifts).length > 0">
                        <div v-for="(shifts_arr, date) in leave.shifts" :key="date" class="d-inline">
                          <small
                              v-for="shift in shifts_arr"
                              :key="shift.id || shift.code || shift.name"
                              v-b-tooltip.hover
                              :title="`Date: ${date} - Shift: ${shift.name} : ${moment(shift.start_time, 'hh:mm A').format('hh:mm A')} - ${moment(shift.end_time, 'hh:mm A').format('hh:mm A')}`"
                              class="border rounded p-1 mr-1"
                              :style="`background-color:${(shift.color || '#000') + '22'}; color:${shift.color || '#000'};`"
                          >
                            {{ shift.code }}
                          </small>
                        </div>
                      </template>
                      <span v-else>N/A</span>
                    </td>
                    <td class="leave-reason-wrapper w-200">
                      {{leave.reason}} <br />
                      <b-link v-if="leave.attachment" @click="downloadFileContent('/avatar/'+ leave.company_id + '/leaves/' + leave.attachment)"><img :src="$api_url+'/images/download_image.png'"  class="" /> </b-link>
                    </td>
                    <td class="">
                      {{leave.updated_by}}
                    </td>

                    <td class="text-right">
                      <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                      <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-toolbar class="">
                          <b-button-group class="mr-0">
                            <b-button class="mr-3 rounded edit-btn" title="Approve" v-if="leave.flg_status == 0" @click="updateLeaveStatus(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 1)">
                              <b-icon icon="check" class="mr-2" aria-hidden="true" ></b-icon>Approve
                            </b-button>
                            <b-button class="mr-3 rounded edit-btn" title="Reject" v-if="leave.flg_status == 0" @click="updateLeaveStatus(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 2)">
                              <b-icon icon="x" class="mr-2" aria-hidden="true" ></b-icon>Reject
                            </b-button>
                            <b-button class="rounded delete-btn" title="Delete" @click="checkLimits(leave.employee_id)">
                              <b-icon icon="check-circle" class="mr-2" aria-hidden="true"></b-icon>Check Limits
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>

            <div v-if="paginatedData.length == 0" class="list-no-data">
              No records found.
            </div>
            <div v-else class="">
              <div class="clearfix mt-2 mb-4">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                  <li class="page-item disabled m-2">per page. Total {{queue.length}} records found.</li>
                </ul>
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <div class="row justify-content-center no-margin" v-else-if="current_module==2">
          <div class="col-sm-12">
              <b-overlay :show="showoverlay_list" rounded="sm">
                <div class="employee-table-wrapper">
                  <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table">
                      <thead>
                          <tr class="table-head">

                            <td class="checkbox-col"><input type="checkbox" v-model="selectAll"/><label for=""></label></td>
                              <th class="cursor-pointer" @click="sortBy('name')" :class="sortKey === 'name' ? (sortOrders['name'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Employee</th>
                              <th class="cursor-pointer" @click="sortBy('department')" :class="sortKey === 'department' ? (sortOrders['department'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Department</th>
                              <th class="cursor-pointer" @click="sortBy('jobposition')" :class="sortKey === 'jobposition' ? (sortOrders['jobposition'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Job Position</th>
                              <th class="cursor-pointer" @click="sortBy('time')" :class="sortKey === 'time' ? (sortOrders['time'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Time</th>
                              <th class="cursor-pointer" @click="sortBy('date')" :class="sortKey === 'date' ? (sortOrders['date'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Date</th>
                              <th class="cursor-pointer" @click="sortBy('location')" :class="sortKey === 'location' ? (sortOrders['location'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Mobility Type</th>
                              <th class="cursor-pointer" @click="sortBy('note')" :class="sortKey === 'note' ? (sortOrders['note'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Note</th>
                              <th class="text-center">Action</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(application , i) in paginatedData" :key="i" class="table-row hover-bg">
                            <td class="checkbox-col">
                              <input type="checkbox" class="justify-content-center" v-model="selected" :value="application.application_id" />
                              <label for=""></label>
                            </td>
                            <td class="border-left">
                              <div class="img-holder">
                                <img v-bind:src="$api_url+'/avatar/'+ application.company_id + '/' + application.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                              </div>
                              {{ application.name }}
                            </td>
                            <td class="border-left">{{ application.department }}</td>
                            <td class="border-left">{{ application.jobposition }}</td>

                              <td>{{ application.time }}</td>
                              <td>{{ application.date }}</td>

                              <td>{{ application.location }}</td>
                              <td class="leave-reason-wrapper w-200">{{ application.note }}</td>

                              <td class="position-relative text-center" >
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                  href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <b-icon icon="three-dots-vertical"></b-icon>
                                </a>

                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                  <b-button-toolbar>
                                    <b-button-group class="mr-0">
                                      <b-button class="mr-3 rounded edit-btn" title="Approve"
                                                @click="updateStatus([application.application_id], 1)">
                                        <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                                      </b-button>

                                      <b-button class="mr-3 rounded edit-btn" title="Reject"
                                                @click="updateStatus([application.application_id], 2)">
                                        <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                      </b-button>
                                    </b-button-group>
                                  </b-button-toolbar>
                                </div>
                              </td>
                            </tr>
                      </tbody>
                  </table>
                </div>

                  <div v-if="queue.length == 0" class="list-no-data">
                      No records found.
                  </div>
                   <div v-else class="">
                      <div class="clearfix mt-2 mb-4">
                          <ul class="pagination b-pagination float-left mb-0 mt-1">
                              <li class="page-item disabled m-2">View</li>
                              <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                              <li class="page-item disabled m-2">per page. Total {{queue.length}} records found.</li>
                          </ul>
                          <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

                      </div>
                  </div>
              </b-overlay>
          </div>
      </div>
      <div class="row justify-content-center no-margin" v-else-if="current_module==3">
        <div class="col-sm-12">
          <b-overlay :show="showoverlay_list" rounded="sm">
            <div class="employee-table-wrapper">
              <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table">
                <thead>
                  <tr class="table-head">
                    <td class="checkbox-col">
                      <input type="checkbox" v-model="selectAll" />
                      <label for=""></label>
                    </td>
                    <th class="cursor-pointer" @click="sortBy('name')" :class="sortKey === 'name' ? (sortOrders['name'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Employee</th>
                    <th class="cursor-pointer" @click="sortBy('department')" :class="sortKey === 'department' ? (sortOrders['department'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Department</th>
                    <th class="cursor-pointer" @click="sortBy('jobposition')" :class="sortKey === 'jobposition' ? (sortOrders['jobposition'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Job Position</th>
                    <th class="cursor-pointer" @click="sortBy('check_in')" :class="sortKey === 'check_in' ? (sortOrders['check_in'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Check In Time</th>
                    <th class="cursor-pointer" @click="sortBy('check_out')" :class="sortKey === 'check_out' ? (sortOrders['check_out'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Check Out Time</th>
                    <th class="cursor-pointer" @click="sortBy('date')" :class="sortKey === 'date' ? (sortOrders['date'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Date</th>
                    <th class="cursor-pointer" @click="sortBy('note')" :class="sortKey === 'note' ? (sortOrders['note'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">Note</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(application , i) in paginatedData" :key="i" class="table-row hover-bg">
                    <td class="checkbox-col">
                      <input
                        type="checkbox"
                        class="justify-content-center"
                        v-model="selected"
                        :value="application.application_id"
                      />
                      <label for=""></label>
                    </td>
                    <td class="border-left">
                      <div class="img-holder">
                        <img v-bind:src="$api_url+'/avatar/'+ application.company_id + '/' + application.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                      </div>
                      {{ application.name }}
                    </td>

                    <td class="border-left">{{ application.department }}</td>
                    <td class="border-left">{{ application.jobposition }}</td>
                    <td>{{ (application.check_in ?? '').toString().substring(0, 5) }}</td>
                    <td>{{ (application.check_out ?? '').toString().substring(0, 5) }}</td>
                    <td>{{ application.date }}</td>
                    <td class="leave-reason-wrapper w-200">{{ application.note }}</td>

                    <td class="position-relative text-right">
                      <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                        href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <b-icon icon="three-dots-vertical"></b-icon>
                      </a>

                      <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-toolbar>
                          <b-button-group class="mr-0">
                            <b-button class="mr-3 rounded edit-btn" title="Approve"
                                      @click="updateStatus([application.application_id], 1)">
                              <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                            </b-button>

                            <b-button class="mr-3 rounded edit-btn" title="Reject"
                                      @click="updateStatus([application.application_id], 2)">
                              <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="queue.length == 0" class="list-no-data">
              No records found.
            </div>

            <div v-else class="">
              <div class="clearfix mt-2 mb-4">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled">
                    <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
                  </li>
                  <li class="page-item disabled m-2">per page. Total {{queue.length}} records found.</li>
                </ul>

                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>

      <div class="row justify-content-center no-margin" v-else-if="current_module==4">
          <div class="col-sm-12">
              <b-overlay :show="showoverlay_list" rounded="sm">
              <div class="employee-table-wrapper">
                  <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
                  <thead class="table-head">
                  <tr class="table-head">
                      <th v-for="column in swapColumns" :key="column.name"
                          @click="sortBy(column.name)"
                          :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                          class="cursor-pointer">
                      <span>{{ column.label }}</span>
                      </th>
                      <th class="text-right" >Actions</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="swap in paginatedData" :key="swap.id" class="hover-bg table-row border-bottom mx-2">
                      <td>
                      {{ swap.from_employee_name }}
                      </td>
                      <td v-b-tooltip.hover.top="swap.from_shift ? (swap.from_shift.start_time + '-' + swap.from_shift.end_time) : ''">
                      {{ swap.from_shift ? swap.from_shift.name + ' ' + swap.from_shift.code : '—' }}
                      </td>
                      <td>{{ swap.from_date }}</td>
                      <td>
                      {{ swap.to_employee_name }}
                      </td>
                      <td v-b-tooltip.hover.top="swap.to_shift ? (swap.to_shift.start_time + '-' + swap.to_shift.end_time) : ''">
                      {{ swap.to_shift ? swap.to_shift.name + ' ' + swap.to_shift.code : '—' }}
                      </td>
                      <td>{{ swap.to_date }}</td>
                      <td class="reason-text">
                      {{ swap.reason }}
                      </td>
                      <td>
                      {{ swap.updated_by }}
                      </td>

                      <td class="text-center">
                      <span class="leave-status" v-if="swap.status == 1"><i class="far fa-dot-circle mr-1 text-success"></i>Approved</span>
                      <span class="leave-status" v-else-if="swap.status == 0"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                      <span class="leave-status" v-else-if="swap.status == 2"><i class="far fa-dot-circle mr-1 text-danger"></i>Declined</span>
                      </td>
                      <td class="text-right">
                      <div v-if="swap.status == 0" class="action">
                          <b-button-toolbar class="float-right position-relative">
                          <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                          <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                              <b-button-group class="">
                              <b-button class="mr-3 rounded edit-btn" title="Approve"
                                          @click="openSwapApproval(swap)">
                                  <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                              </b-button>

                              <b-button class="mr-3 rounded edit-btn" title="Reject"
                                          @click="updateStatus([swap.id], 2)">
                                  <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                              </b-button>
                              </b-button-group>
                          </div>
                          </b-button-toolbar>
                      </div>
                      </td>
                  </tr>
                  </tbody>
                  </table>
              </div>
              </b-overlay>
          </div>
      </div>


      <b-modal id="bv-modal-swap-approve" title="Approve Swap Request" hide-footer size="lg" @hidden="resetSwapApproval">
          <div v-if="swapApproval.swap">
              <table class="table table-bordered mb-3">
                  <tr>
                  <th>From Employee</th>
                  <td>{{ swapApproval.swap.from_employee_name }}</td>
                  </tr>
                  <tr>
                  <th>From Shift</th>
                  <td>{{ swapApproval.swap.from_shift ? swapApproval.swap.from_shift.name + ' (' + swapApproval.swap.from_shift.start_time + ' - ' + swapApproval.swap.from_shift.end_time + ')' : '—' }}</td>
                  </tr>
                  <tr>
                  <th>From Date</th>
                  <td>{{ swapApproval.swap.from_date }}</td>
                  </tr>
                  <tr>
                  <th>To Employee</th>
                  <td>{{ swapApproval.swap.to_employee_name }}</td>
                  </tr>
                  <tr>
                  <th>To Shift</th>
                  <td>{{ swapApproval.swap.to_shift ? swapApproval.swap.to_shift.name + ' (' + swapApproval.swap.to_shift.start_time + ' - ' + swapApproval.swap.to_shift.end_time + ')' : '—' }}</td>
                  </tr>
                  <tr>
                  <th>To Date</th>
                  <td>{{ swapApproval.swap.to_date }}</td>
                  </tr>
                  <tr v-if="swapApproval.swap.reason">
                  <th>Reason</th>
                  <td>{{ swapApproval.swap.reason }}</td>
                  </tr>
              </table>

              <b-form-group label-for="replacement_employee" class="mb-3">
                  <template #label>
                  Replace Employee's vacated shift
                  <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Optionally select an employee to cover the shift left behind by the to-employee after the swap.'"></b-icon>
                  </template>
                  <b-form-select id="replacement_employee" v-model="swapApproval.replacement_id" :options="swapApproval.replacementOptions" :disabled="swapApproval.loadingReplacements">
                  <template #first>
                      <b-form-select-option :value="null">No replacement needed</b-form-select-option>
                  </template>
                  </b-form-select>
                  <small class="text-muted d-block mt-1">Leave empty if no replacement is needed.</small>
              </b-form-group>

              <div class="d-flex justify-content-end">
                  <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('bv-modal-swap-approve')">Cancel</b-button>
                  <b-button variant="primary" :disabled="swapApproval.submitting" @click="confirmSwapApproval">
                  <b-icon icon="check2-circle" class="mr-1"></b-icon> Confirm Approval
                  </b-button>
              </div>
          </div>
      </b-modal>
    <b-modal id="employeeLeavesLimits" hide-footer title="Allowed Leaves" dialog-class="w-1000">
      <div class="row mt-4">

        <div class="col-sm-12 table-responsive">
          <table class="table">
            <thead>
            <tr class="table-head">
              <th>Type</th>
              <th>Leaves Allowed</th>
              <th v-if="carry == 1">Carried</th>
              <th>Available</th>
              <th>Applied</th>
              <th>Enjoyed</th>
              <th>Deducted</th>
              <th v-if="encash == 1">Encashed</th>
              <th>Remaining</th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
              <td>
                <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                {{leave_type.leave_title}}
              </td>

              <td>{{leave_type.allowed}} Days</td>

              <td v-if="carry == 1">{{leave_type.carried}} Days</td>
              <td>{{leave_type.leave_days}} Days</td>
              <td>{{leave_type.applied}} Days</td>
              <td>{{leave_type.enjoyed}} Days</td>
              <td>{{leave_type.deducted}} Days</td>
              <td v-if="encash == 1">{{leave_type.encashed}} Days</td>
              <td>{{leave_type.remaining}} Days</td>
            </tr>
            </tbody>
          </table>

        </div>

      </div>
    </b-modal>
  </div>

</template>

<script>
import moment from 'moment';
export default {
  props: [],
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Employee', name: 'employee_name' },
      {label: 'Job Position', name: 'employee_code' },
      {label: 'Department', name: 'department' },
      {label: 'Leave Category', name: 'leave_type'},
      {label: 'From', name: 'from'},
      {label: 'To', name: 'to'},
      {label: 'No. of Days/Shifts', name: 'number_of_days'},
      {label: 'Shift(s)', name: 'shifts'},
      {label: 'Reason', name: 'reason'},
      {label: 'Updated By', name: 'updated_by'},
    ];
    columns.forEach((column) => {sortOrders[column.name] = -1;});
    return {

      queue:[],
      modules : {
        1: 'Leave',
        2: 'Mobility Attendance',
        3: 'Attendance Adjustment',
        4: 'Schedule Swap',
      },
      swapColumns: [
          { label: 'From Employee', name: 'from_employee_name' },
          { label: 'From Shift', name: 'from_shift' },
          { label: 'From Date', name: 'from_date' },
          { label: 'To Employee', name: 'to_employee_name' },
          { label: 'To Shift', name: 'to_shift' },
          { label: 'To Date', name: 'to_date' },
          { label: 'Reason', name: 'reason' },
          { label: 'Updated By', name: 'updated_by' },
          { label: 'Status', name: 'status' },
      ],
      swapApproval: {
        swap: null,
        replacement_id: null,
        replacementOptions: [],
        replacementShift: null,
        loadingReplacements: false,
        submitting: false,
      },
      carry: 0,
      encash: 0,
      current_module : 1,
      selected_bulk_option : 0,
      application_date: new Date().toISOString().slice(0, 10),
      selected:[],
      leave_available:[],
      bulk_options:[
        {value:0, text: 'Bulk Option'},
        {value:1, text:'Approve Selected'},
        {value:2, text:'Reject Selected'},
      ],
      showoverlay_list:false,
      pagination: {currentPage: 1, pages:1},
      temp_length: 10,
      roster: 0,
      columns: columns,
      sortKey: 'employee_name',
      sortOrders: sortOrders,
      length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                              { value: 50, text: "50" },
                                              { value: 100, text: "100" },
                                              { value: 200, text: "200" },
                                              { value: 500, text: "500" }, ],
    };
  },
  methods: {
    moment,

    openSwapApproval(swap) {
        if(!swap.is_final_approver) {
          this.updateStatus([swap.application_id], 1);
          return;
        }
        let formData = new FormData();
        formData.append('zombie', swap.employee_id);
        axios.post(this.$api_url+'/front/leave-attendance/manager/set', formData).then((response) =>
            {                                                                    
                this.swapApproval.swap = swap;
                this.swapApproval.replacement_id = null;
                this.swapApproval.replacementOptions = [];
                this.swapApproval.replacementShift = null;
                this.$bvModal.show('bv-modal-swap-approve');
                this.loadReplacementEmployees(swap);
            })
            .catch((error) => 
            {
                this.serverError(error);
            });
        
    },

    loadReplacementEmployees(swap) {
        this.swapApproval.loadingReplacements = true;

        axios.get(this.$api_url + '/front/leave-attendance/swaps/' + swap.application_id + '/replacement-options')
        .then((response) => {
            this.swapApproval.replacementShift = response.data.shift;
            this.swapApproval.replacementOptions = response.data.employees || [];
            this.swapApproval.loadingReplacements = false;
        })
        .catch(() => {
            this.swapApproval.loadingReplacements = false;
        });
    },

    confirmSwapApproval() {
        this.swapApproval.submitting = true;
        const swap = this.swapApproval.swap;

        const payload = {
        ids: [swap.application_id],
        status: 1,
        replacement_employee_id: this.swapApproval.replacement_id,
        };

        axios.post(this.$api_url + '/front/leave-attendance/approver/application/' + this.current_module, payload)
        .then(() => {
            this.$bvToast.toast('Swap approved!', { variant: 'success', solid: true, title: 'Success' });
            this.$bvModal.hide('bv-modal-swap-approve');
            this.getQueue();
        })
        .catch((error) => {
            this.serverError(error);
        })
        .finally(() => {
            this.swapApproval.submitting = false;
        });
    },

    resetSwapApproval() {
        this.swapApproval = {
        swap: null,
        replacement_id: null,
        replacementOptions: [],
        replacementShift: null,
        loadingReplacements: false,
        submitting: false,
        };
    },
    checkLimits(employee_id){
      axios.get(this.$api_url + '/front/leave-attendance/employee/leaves', {
        params: {
          employee_id:employee_id
        }
      }).then(response => {
        this.leave_available = response.data.available;
        this.$bvModal.show('employeeLeavesLimits');
      });
    },
    getSettings() {
      Promise.all([
        axios.get(this.$api_url + '/front/leave-attendance/approver/settings/1'),
        axios.get(this.$api_url + '/front/leave-attendance/approver/settings/2')
      ]).then(([mod1, mod2]) => {
        if (mod1.data['status'] == 1) {
          this.modules.push({ value: 1, text: 'Leave' });
        }

        if (mod2.data['status'] == 1) {
          this.modules.push({ value: 2, text: 'Attendance' });
        }

        if (this.modules.length > 0) {
          this.current_module = this.modules[0].value;
          this.getQueue();
        }
      });
    },

    confirmUpdateStatus(status){
      if(status == 0) return;
      if(this.selected.length == 0) {
        this.$bvToast.toast('No items selected', {
          variant: 'danger',
          title: 'Failed',
          solid: true,
        });
        this.selected_bulk_option = 0;
        return;
      }
      const actionText = status == 1 ? 'approve' : 'reject';
      this.$bvModal.msgBoxConfirm(
          `Do you want to ${actionText} the selected applications?`,
          {
            title: 'Are you sure?',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'No',
            headerClass: 'p-2 border-bottom-0',
            titleClass: 'w-100 text-center',
            bodyClass: 'text-center',
            footerClass: 'p-2 border-top-0 justify-content-center',
            centered: true
          }
      ).then(confirmed => {
        if (!confirmed) return;
        this.updateStatus(this.selected, status);
      });
    },
    updateLeaveStatus(employee_id,leave_type_id,flg_status,from,to , status){
      this.showoverlay_list = true;
      axios.post(this.$api_url + '/front/leave-attendance/approver/application/'+this.current_module, {
            "employee_id": employee_id,
            "leave_type_id": leave_type_id,
            "from": from,
            "status": status,
            "to": to,
            "flg_status": flg_status,
          }).then(function (response) {
        this.$bvToast.toast('Updated!', {
          title: `Success`,
          variant: 'success',
          solid: true
        });
        this.getQueue();
      }.bind(this)).catch((error) => {
        this.showoverlay_list = false;
        this.serverError(error);
      });
    },

    updateStatus(ids, status){

      this.showoverlay_list = true;
      axios.post(this.$api_url + '/front/leave-attendance/approver/application/'+this.current_module, {'ids': ids,'status':status}).then(function (response) {
            this.$bvToast.toast('Updated!', {
                  title: `Success`,
                  variant: 'success',
                  solid: true
                });
            this.getQueue();
            this.selected_bulk_option = 0;
            this.selected = [];
        }.bind(this)).catch((error) => {
            this.showoverlay_list = false;
            this.selected_bulk_option = 0;
            this.serverError(error);
        });

    },
    changeModule() {
      if (this.current_module === 1) {
        this.sortKey = 'employee_name';
      } else {
        this.sortKey = 'name';
      }
      this.selected = [];
      this.selected_bulk_option = 0;
      this.getQueue();
    },
    sortBy(key) {
      if (this.sortOrders[key] === undefined) {
        this.$set(this.sortOrders, key, 1);
      } else {
        this.sortOrders[key] = this.sortOrders[key] * -1;
      }
      this.sortKey = key;
    },
    getQueue() {
      
      this.selected = [];
      this.selected_bulk_option = 0;
      let params = {};
      if (this.current_module === 1) {
        this.application_date = '';
      } else if ((this.current_module === 2 || this.current_module === 3) && this.application_date) {
        const date = new Date(this.application_date);
        const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!ymdPattern.test(this.application_date) || isNaN(date.getTime())) {
          return;
        }
        params['application_date'] = this.application_date;
      }
      this.showoverlay_list = true;

      axios.get(`${this.$api_url}/front/leave-attendance/approver/queue/${this.current_module}`, { params }).then(response => {
            this.queue = response.data;
            this.showoverlay_list = false;
          }).catch(error => {
            this.showoverlay_list = false;
            this.serverError(error);
          });
    },
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;

          this.carry = response.data.carry;
          this.encash = response.data.encash;

          this.columns = this.columns.map(column => ({ ...column }));

          this.columns = this.columns.map(column => {
            if (column.name == 'number_of_days') {
              return {
                ...column,
                label: 'No. of Days' + (this.roster == 1 ? '/Shifts' : '')
              };
            }

            return column;
          });

          if (this.roster != 1) {
            this.columns = this.columns.filter(column => column.name != 'shifts');
          }
        }
      }.bind(this));
    },
  },
  created() {
      this.getCompanyLeaveSettings();
      this.getQueue();
    },

    computed:{
      filteredData()
      {
          let filtered_list = this.queue;
          this.people = filtered_list.length;
          if (this.search)
          {
              filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

              if(filtered_list.length == 0)
                  this.blankmsg = "Nothing found.";
          }

          if (this.sortKey) {
              const key = this.sortKey;
              const order = this.sortOrders[key] || 1;
              filtered_list = filtered_list.slice().sort((a, b) => {
                  let valA = a[key];
                  let valB = b[key];
                  
                  if (valA === null || valA === undefined || valA === '-') valA = '';
                  if (valB === null || valB === undefined || valB === '-') valB = '';
                  
                  if (key === 'number_of_days') {
                      valA = parseFloat(valA) || 0;
                      valB = parseFloat(valB) || 0;
                  } else {
                      if (typeof valA === 'string') valA = valA.toLowerCase();
                      if (typeof valB === 'string') valB = valB.toLowerCase();
                  }
                  
                  if (valA > valB) return order;
                  if (valA < valB) return -order;
                  return 0;
              });
          }

          return filtered_list;
      },
      paginatedData()
      {
          return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
      },

      selectAll: {
        get: function () {
          if (this.paginatedData.length === 0) return false;
          return this.paginatedData.every(item => this.selected.includes(item.application_id));
        },
        set: function (value) {
          let selected = [...this.selected];
          this.paginatedData.forEach(item => {
            const index = selected.indexOf(item.application_id);
            if (value) {
              if (index === -1) {
                selected.push(item.application_id);
              }
            } else {
              if (index !== -1) {
                selected.splice(index, 1);
              }
            }
          });
          this.selected = selected;
        }
      },
    }

};
</script>
